import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { DashboardRootViewComponent } from './dashboard-root-view.component';

export const ngxDashboardRootViewModule = angular.module('ngxDashboardRootViewModule', [])
	.directive('ngxDashboardRootView', downgradeComponent({ component: DashboardRootViewComponent }))
	.name;
